import { forwardRef, RefObject } from 'react';
import { useTranslations } from 'next-intl';
import { IProduct, IProductSectionName } from '@monofront/types';
import RedirectionCard, {
  Button,
  Subtitle,
  Title,
} from '@monofront/design-system/components/RedirectionCard';
import ArrowRight from '@monofront/design-system/visuals/Icons/ArrowRight';
import { IconSizes } from '@monofront/design-system/visuals/Icons/type';

interface IProductCoCreationProps {
  product: IProduct;
  name: IProductSectionName;
  ref: RefObject<HTMLHeadingElement | null>;
}

const ProductCoCreation = forwardRef<
  HTMLHeadingElement,
  IProductCoCreationProps
>(({ product, name }, ref) => {
  const tProducts = useTranslations('Products');
  const whyCoCreation = product.meta.marketing?.why_co_creation;
  const coCreationLink = product.meta.marketing?.co_creation_survey_link;

  if (!whyCoCreation) return null;

  return (
    <>
      <h2
        ref={ref}
        id="section-cocreation"
        className="section-title tw-lf-title-sm tw-mb-6 tw-mt-[4.5rem] desktop:tw-lf-title-md"
        data-menu={name.menuTitle ? name.menuTitle : tProducts('coCreation')}
        tabIndex={-1}
      >
        {name.sectionTitle
          ? name.sectionTitle.replace('%PRODUCT_NAME%', product.title)
          : tProducts('coCreation')}
      </h2>
      <div
        className="tw-lf-rich-text"
        dangerouslySetInnerHTML={{
          __html: whyCoCreation,
        }}
      />
      {coCreationLink && (
        <RedirectionCard
          url={coCreationLink}
          isTargetBlank
          UNSAFE_className="tw-mt-6 tw-mb-4"
        >
          <Title>{tProducts('coCreationLinkTitle')}</Title>
          <Subtitle>{tProducts('coCreationLinkSubTitle')}</Subtitle>
          <Button>
            <ArrowRight size={IconSizes.md} />
          </Button>
        </RedirectionCard>
      )}
    </>
  );
});

export default ProductCoCreation;
